import DateFilter from './DateFilter';
import DropdownFilter from './DropdownFilter';
import SmallTextFilter from './SmallTextFilter';


export const DATE = DateFilter;
export const MULTISELECT = DropdownFilter;
export const SMALLTEXT = SmallTextFilter;
export const DROPDOWN = SmallTextFilter;
